import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import styles from "./App.modules.scss";
import Quiz from "./Quiz";
import SuccessPage from "./components/steps/SuccessPage";
import ComparisonPopup from "./components/features/ComparisonPopup";
import PaymentResultPage from "./components/steps/PaymentResultPage";
import { captureTrackingParams } from "./api";

const App = () => {
  const [showPopup, setShowPopup] = useState(false);

  // Capture gclid/wbraid/gbraid/UTM from URL into cookies on every page load
  useEffect(() => { captureTrackingParams(); }, []);

  const handleShowPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className={styles.appContainer}>
      <Routes>
        <Route path="/" element={<Quiz onShowComparisonPopup={handleShowPopup} />} />
        <Route 
          path="/success" 
          element={
            <SuccessPage 
              title="Дякую!" 
              subtitle="Ваша заявка прийнята, ми незабаром з Вами зв’яжемось"
            />
          }
        />
        <Route 
          path="/success-payment" 
          element={
            <SuccessPage 
              title="Дякуємо за оплату!" 
              subtitle="Ваша заявка вже в роботі, ми незабаром з Вами зв’яжемось"
            />
          }
        />
        <Route path="/payment-result/:order_id" element={<PaymentResultPage />} />
      </Routes>
      {showPopup && <ComparisonPopup onClose={handleClosePopup} />}
    </div>
  );
};

export default App;
